import React, { Component } from "react"
import { graphql } from 'gatsby'
import SEO from "../components/seo"
import Link from "../utils/link"
import Drummond from '../assets/images/drummond.jpg'

class ShopPage extends Component {

  render() {
    
    const products = this.props.data.allShopifyProduct

    return (
      <>
        <SEO title={'Shop - Emily Gillis'} bodyClass='projects' description={'Products from Emily Gillis Interior Design'} />
        <section className='page'>
          <div className='page__inner'>
            <div className='shop__items'>
              { products && products.nodes.map((el, i) => {
                let { title, handle, media, priceRange } = el
                return (
                  <div className='shop__item' key={i}>
                    <div className='shop__image'>
                      { media.length > 0 &&
                        <img src={media[0].image.originalSrc} alt={title} />
                      }
                    </div>
                    <h4 className='shop__title'>{title}</h4>
                    <span>${parseFloat(priceRange.minVariantPrice.amount).toFixed(2)}</span>
                    <Link className='shop__link' to={`/product/${handle}`}></Link>
                  </div>
                )
              }) }
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default ShopPage

export const shopQuery = graphql`
  query shopQuery {
    allShopifyProduct {
      nodes {
        id
        shopifyId
        title
        handle
        media {
          ... on ShopifyMediaImage {
            image {
              originalSrc
            }
          }
        }
        priceRange : priceRangeV2 {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
